
import React, { Component } from "react";
import Toolbar from '@material-ui/core/Toolbar';
import {reduxForm, } from 'redux-form';
import {connect} from 'react-redux';


class NDF extends Component {
    constructor(props){
        super();
        this.state={
            open : false,
            tableData : {
                rows : [
                    {}
                ]
            },
            pagination : {
                meta : {
                    currentPage: 5,
                    defaultPageSize: 10,
                    pageSize: 5,
                    totalPages: 5,
                    totalRecords: 50
                }
            }
        };
    }

    render() {
        return (
            <main className="content-engage">
                <Toolbar />
                <div className="activityTitle-engage">
                    <h3> No Data Found!</h3>
                </div>
            </main>
        );
    }
}

function mapStateToProps(state,dispatch) {
    return {
        abc : true
    }
}


NDF = reduxForm({
    form: 'NDFForm',
})(NDF);

export default connect(mapStateToProps, {})(NDF);

